import React from 'react'
import { GrowthMetricHeatmapChart } from './GrowthMetricHeatmapShared'
import { formatWithCommaSeparator, resolveGeographySubtitleLabel } from './NetFlowsHeatmapShared'

const AUM_HEATMAP_COLORS = {
  belowZero: { color: 'rgb(229, 84, 108)', fontColor: '#ffffff' },
  zeroToFive: { color: 'rgb(204, 255, 255)', fontColor: '#000000' },
  fiveToTen: { color: 'rgb(0, 176, 240)', fontColor: '#000000' },
  tenToFifteen: { color: 'rgb(31, 64, 230)', fontColor: '#ffffff' },
  aboveFifteen: { color: 'rgb(0, 32, 96)', fontColor: '#ffffff' },
  na: { color: 'rgb(230, 230, 230)', fontColor: '#000000' },
}

const AUM_HEATMAP_CONFIG = {
  colorMap: AUM_HEATMAP_COLORS,
  bucketRules: [
    { min: 0, max: 5, key: 'zeroToFive' },
    { min: 5, max: 10, key: 'fiveToTen' },
    { min: 10, max: 15, key: 'tenToFifteen' },
    { min: 15, max: Infinity, key: 'aboveFifteen' },
  ],
  formatDisplayValue: formatWithCommaSeparator,
  getHeaderTitle: (endYear) => `Assets Under Management at YE ${endYear}`,
  getLegendTitleSingle: (firstYear) => `AUM CAGR, ${firstYear}`,
  getLegendTitleMulti: (yearsLabel) => `AUM CAGR, ${yearsLabel}`,
  getTotalColumnLabel: (endYear) => `Total AUM (${endYear})`,
  growthAxisTitle: 'AUM growth %',
  seriesName: 'AUM growth %',
  dataClasses: [
    { from: 15, color: AUM_HEATMAP_COLORS.aboveFifteen.color, name: '≥15%' },
    { from: 10, to: 15, color: AUM_HEATMAP_COLORS.tenToFifteen.color, name: '10–15%' },
    { from: 5, to: 10, color: AUM_HEATMAP_COLORS.fiveToTen.color, name: '5–10%' },
    { from: 0, to: 5, color: AUM_HEATMAP_COLORS.zeroToFive.color, name: '0–5%' },
    { from: -100, to: -0.0001, color: AUM_HEATMAP_COLORS.belowZero.color, name: '<0%' },
    { from: -0.0001, to: 0, color: AUM_HEATMAP_COLORS.na.color, name: 'n/a' },
  ],
  buildMainCellHoverText: ({ displayValue, growthText, rowAxisLabel, yName, xName, yearsLabel }) =>
    `<b>AUM: ${displayValue}</b><br />${growthText}<br />${rowAxisLabel}: ${yName}<br />Asset class: ${xName}${yearsLabel ? `<br />Years: ${yearsLabel}` : ''}`,
  buildColumnTotalHoverText: ({ displayValue, rowAxisLabel, rowName }) =>
    `AUM total: <b>${displayValue}</b><br />${rowAxisLabel}: ${rowName}`,
  buildRowTotalHoverText: ({ displayValue, columnName }) =>
    `AUM total: <b>${displayValue}</b><br />Asset class: ${columnName}`,
  buildGrandTotalHoverText: ({ displayValue, endYear }) =>
    `AUM Grand Total (${endYear}): <b>${displayValue}</b>`,
}

export const AumHeatmapChart = (props) => (
  <GrowthMetricHeatmapChart {...props} config={AUM_HEATMAP_CONFIG} />
)

const AumHeatmap = (props) => (
  <AumHeatmapChart
    {...props}
    rowAxisLabel="Client segment"
    resolveFilterSubtitleLabel={resolveGeographySubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} AUM {series.yAxis.categories.(y)}, {value}."
  />
)

export default AumHeatmap
